/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import template from "./ns-card.html";

/**
 * <br>
 * UX stuff here
 * <section>
 *  <h2>Content Guidelines</h2>
 *  <p>Here are some guidelines on how to properly use this element.</p>
 * </section>
 *
 * <h1>Card</h1>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-card src="https://via.placeholder.com/125x125">Sample Card</ns-card>
 *   </template>
 * </demo-snippet>
 *
 * @defaultText Example Card
 *
 */
export class NsCard extends PolymerElement {
  constructor() {
    super();
  }

  static get is() {
    return "ns-card";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      /**
       * Alternate text for card image for screen readers
       */
      alt: String,
      /**
       * Card link
       */
      href: String,
      /**
       * Image source for card image
       */
      src: String
    };
  }

  ready() {
    super.ready();
  }
}
customElements.define(NsCard.is, NsCard);
